import { render, staticRenderFns } from "./EvidenceUpload.vue?vue&type=template&id=4eb2f6b6&scoped=true&"
import script from "./EvidenceUpload.vue?vue&type=script&lang=js&"
export * from "./EvidenceUpload.vue?vue&type=script&lang=js&"
import style0 from "./EvidenceUpload.vue?vue&type=style&index=0&id=4eb2f6b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb2f6b6",
  null
  
)

export default component.exports